/** 市场类型 / 充值提现引导页 query.type 取值 */
export const MARKET_TYPE_GUIDE_QUERY = {
  BINARY: 'market_binary',
  DIVERSITY: 'market_diversity',
  REFILL: 'refill',
  WITHDRAWAL: 'withdrawal',
};

/** 创建市场问题类型 id → query.type */
export const CREATE_MARKET_TYPE_GUIDE_MAP = {
  binary: MARKET_TYPE_GUIDE_QUERY.BINARY,
  multi: MARKET_TYPE_GUIDE_QUERY.DIVERSITY,
};
